import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function AuthoritySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="font-heading text-xs md:text-sm text-foreground-400 italic mb-3">
            Superbuy Spreadsheet Research Team
          </p>
          <h2 className="font-heading text-3xl md:text-6xl font-bold text-foreground-900 leading-tight max-w-3xl mx-auto">
            UNMATCHED <span className="font-heading italic font-normal text-foreground-600">data</span> RESOURCES
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            We are the most comprehensive Superbuy Spreadsheet resource platform, combining expert-curated product
            databases with educational content that empowers international shoppers to make smarter, safer purchasing decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to="/superbuy-spreadsheet-beginner-guide"
            className="group relative bg-accent-500 rounded-lg overflow-hidden p-8 md:p-10 flex flex-col justify-between min-h-[320px] cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
          >
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 text-white cursor-pointer group-hover:bg-white/30 transition-colors">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </div>
            <div>
              <span className="font-heading text-6xl md:text-7xl font-bold text-white block leading-none">
                2026
              </span>
              <p className="text-white/90 text-lg mt-3 font-semibold">Complete Beginner Guide</p>
              <p className="text-white/70 text-sm mt-2 max-w-xs leading-relaxed">
                Learn everything from spreadsheet basics to advanced shopping workflows with our step-by-step guide.
              </p>
            </div>
            <p className="text-white/50 text-xs italic mt-6">Updated weekly · Trusted Authority</p>
          </Link>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-secondary-500 rounded-lg overflow-hidden p-8 md:p-10 flex flex-col justify-between min-h-[320px] cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
          >
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 text-white cursor-pointer group-hover:bg-white/30 transition-colors">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </div>
            <div>
              <span className="font-heading text-6xl md:text-7xl font-bold text-white block leading-none">
                14+
              </span>
              <p className="text-white/90 text-lg mt-3 font-semibold">Product Categories</p>
              <p className="text-white/70 text-sm mt-2 max-w-xs leading-relaxed">
                Browse our extensive collection of categorized products with direct links, pricing information, and quality references.
              </p>
            </div>
            <p className="text-white/50 text-xs italic mt-6">Visit Main Platform →</p>
          </a>
        </div>
      </div>
    </section>
  );
}